//------------------
// assign sequence
//------------------
export default function assignSequence(item, index, arr) {
  //-------------------------------------
  // set seq = 0 where status = inactive
  //-------------------------------------
  if (arr[index].status == "Inactive") {
    arr[index].seq = 0;
    //--------------------
    // else increment seq
    //--------------------
  } else {
    arr[index].seq = index + 1;
  }
}
